import { Injectable } from '@angular/core';

import { ExerciseModel } from '../../models/models';
import { ApiProvider } from '../api/api';

@Injectable()
export class ExerciseProvider {
  private items: ExerciseModel[] = [];

  constructor(
    private api: ApiProvider
    ) {
  }

  Exists(item: ExerciseModel): boolean {
    return this.items.find(x => {
      return x._id !== item._id && x.Name === item.Name && x.Variation === item.Variation;
    }) !== undefined;
  }

  List(force: boolean = false) {
    return new Promise((resolve, reject) => {
      if (this.items.length === 0 || force) {
        this.api.get('exercise/').subscribe((data) => {
          const arr = data.json();
          let obj: ExerciseModel[] = [];
          for(var j = 0; j < arr.length; j++) {
            var item = arr[j];
            var exercise = {
              _id: item.id,
              Name: item.name,
              Variation: item.variation
            } as ExerciseModel;
            this.SetFullName(exercise);
            obj.push(exercise);          
          }
          this.items = obj;
          this.Sort();
          resolve(this.items);
        });
      }
      else {
        resolve(this.items);
      }
    });
  }

  Load(id) {
    return this.items.find(x => x._id === id);
  }

  Remove(item: ExerciseModel) {
    return new Promise((resolve, reject) => {
      this.api.delete(`exercise/${item._id}`).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          this.items = this.items.filter(m => m._id !== item._id);
          resolve(this.items);
        }
      });
    });
  }

  Save(item: ExerciseModel) {
    return new Promise((resolve, reject) => {
      const isNew = item._id === undefined;

      item._id = item._id || null;

      this.api.post('exercise/', item).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          item._id = data.id;
          this.SetFullName(item);

          if (isNew) {
            // add the item to the list
            this.items.push(item);
          }

          resolve(item);
        }
      });
    });
  }

  SetFullName(item) {
    item.FullName = item.Name;
    if (item.Variation) {
      item.FullName += ` - ${item.Variation}`;
    }
  }

  Sort() {
    this.items.sort((a: ExerciseModel, b: ExerciseModel) => {
      if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
      else if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
      else return 0;
    });
    return this.items;
  }

}



// WEBPACK FOOTER //
// ./src/providers/exercise/exercise.ts